// Die Uebungsarten der Sprechregeln, so wie sie im Auswahlmenue stehen.
// lernziel: steht im Uebungsmodus oben («Lernziel: Ich kann …»).
// Welche Ansicht zu einer Art gehoert, steht in Sprechregeln.vue
// (Tabelle "ansichten") — hier steht nur, was der Lernende liest.
// Eine Art erscheint erst hier, wenn ihre Ansicht gebaut ist.

import { wechseltAb } from '@/logic/Uebung'

// Die vier Stufen der Designprinzipien: vom Erkennen zum Selbst-Sprechen.
// Das Menue gruppiert die Uebungsarten danach.
export const stufen = [
    { id: 'erkennen', name: 'Erkennen' },
    { id: 'ordnen', name: 'Ordnen' },
    { id: 'beurteilen', name: 'Beurteilen' },
    { id: 'produzieren', name: 'Selbst funken' }
]

export const uebungsarten = [
    {
        id: 'einfachSortieren',
        stufe: 'ordnen',
        name: 'Einfach sortieren',
        beschreibung: 'Fertige Sprüche in die richtige Reihenfolge bringen.',
        lernziel: 'Ich kann die Sprüche eines Funkverkehrs in die richtige Reihenfolge bringen.'
    },
    {
        id: 'ablaufgitter',
        stufe: 'ordnen',
        name: 'Ablaufgitter',
        beschreibung: 'Fertige Sprüche der richtigen Station und dem richtigen Zeitpunkt zuordnen.',
        lernziel: 'Ich weiss, welche Station wann welchen Spruch sendet.'
    },
    {
        id: 'allesSortieren',
        stufe: 'ordnen',
        name: 'Alles sortieren',
        beschreibung: 'Jeden Spruch aus Bausteinen bauen.',
        lernziel: 'Ich kann einen Funkspruch aus seinen Bausteinen bauen.'
    },

    // ─── Fehlersuche ── vom Erkennen zum Verbessern ────────────
    {
        id: 'fassungWaehlen',
        stufe: 'erkennen',
        name: 'Richtige Fassung wählen',
        beschreibung: 'Aus drei Fassungen die richtige wählen.',
        lernziel: 'Ich erkenne die richtige Fassung eines Funkspruchs.'
    },
    {
        id: 'fehlerMarkieren',
        stufe: 'beurteilen',
        name: 'Fehler markieren',
        beschreibung: 'Falsche Bausteine in einem Funkverkehr finden.',
        lernziel: 'Ich finde die falschen Bausteine in einem Funkverkehr.'
    },
    {
        id: 'regelBenennen',
        stufe: 'beurteilen',
        name: 'Regel benennen',
        beschreibung: 'Die Regel nennen, gegen die ein Spruch verstösst.',
        lernziel: 'Ich kann sagen, gegen welche Regel ein Spruch verstösst.'
    },
    {
        id: 'fehlerKorrigieren',
        stufe: 'beurteilen',
        name: 'Fehler korrigieren',
        beschreibung: 'Fehlerhafte Sprüche verbessern.',
        lernziel: 'Ich kann einen fehlerhaften Spruch verbessern.'
    },

    // ─── Im Funkverkehr ─────────────────────────────────────────
    {
        id: 'reagieren',
        stufe: 'produzieren',
        name: 'Reagieren',
        beschreibung: 'Selbst funken, die Gegenstation antwortet.',
        lernziel: 'Ich kann selbst richtig auf einen Spruch antworten.'
    }
]

// Geht ein Ablauf mit dieser Uebungsart? Die einzige Stelle, die das
// entscheidet — Menue, Sitzung und Lehrerformular fragen alle hier.
export function passt(artId, schema) {
    if (artId === 'einfachSortieren') return wechseltAb(schema)
    // Reagieren braucht eine Gegenstation, die antwortet; das Ablaufgitter
    // mehr als einen Zug (die Spalten nennen die Stationen, darum geht es
    // auch ohne Abwechseln).
    if (artId === 'ablaufgitter') return schema.zuege.length > 1
    if (artId === 'reagieren') return schema.zuege.length > 1
    return true
}
